import React, { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { ConfirmationDialogModal, IConfirmationModalProps } from "@/components/ConfirmModal";
import { Textarea } from "@/eworkitComponents";

export interface ITaskConfirmationDialogModalProps extends Omit<IConfirmationModalProps, "onAccept"> {
  onAccept: (comment: string) => void;
}

export const TaskConfirmationDialogModal: FC<ITaskConfirmationDialogModalProps> = ({
  children,
  onAccept,
  onClose,
  ...props
}) => {
  const { t } = useTranslation("session");
  const [comment, setComment] = useState<string>("");

  const handleAction = useCallback(
    (close: () => void) => {
      onAccept(comment);
      close();
    },
    [onAccept, comment],
  );

  const handleOnClose = useCallback(() => {
    setComment("");
    onClose?.();
  }, [onClose, setComment]);

  return (
    <ConfirmationDialogModal onAccept={handleAction} onClose={handleOnClose} {...props}>
      <Textarea
        name="comment"
        max={255}
        placeholder={t("TASKS.DIALOG_MODAL.TEXTAREA_COMMENT")}
        value={comment}
        onChange={setComment}
      />

      {children}
    </ConfirmationDialogModal>
  );
};
